import router from '@/router'

/**
 * 路由跳转新窗口
 * @param {Object} route - 路由配置（同router.push的参数）
 * @param {String} target - 窗口目标（默认_blank）
 */
export const openRouteInNewWindow = (route, target = '_blank') => {
    const { href } = router.resolve(route)
    window.open(href, target)
}
